var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.claimable ? _c('purchase-dialog-claim', _vm._b({
    on: {
      "input": function ($event) {
        return _vm.$emit('init');
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true)
  }, 'purchase-dialog-claim', {
    value: _vm.value,
    type: _vm.type
  }, false)) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }